import { render, staticRenderFns } from "./CardForPos.vue?vue&type=template&id=7647e611&scoped=true&"
import script from "./CardForPos.vue?vue&type=script&lang=js&"
export * from "./CardForPos.vue?vue&type=script&lang=js&"
import style0 from "./CardForPos.vue?vue&type=style&index=0&id=7647e611&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647e611",
  null
  
)

export default component.exports